import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styles from "./PasswordResetSent.module.css";
import Nav from "../../components/Nav/Nav";
import Footer from "../../components/Footer/Footer";
import { StaticRoutes } from "../routes";
import classNames from "classnames";

const PasswordResetSent = ({
  navList = [
    {
      label: "HOME",
      options: [],
      border: false,
      path: StaticRoutes.Home,
    },
    {
      label: "PRODUCTS",
      options: [
        { label: "BIDDING", path: StaticRoutes.Bidding },
        { label: "TRIPBOARD", path: StaticRoutes.TripBoard },
        { label: "SENIORITY", path: StaticRoutes.Seniority },
      ],
      border: false,
    },
    {
      label: "PRICING",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: false,
    },
    {
      label: "CONTACT US",
      options: [],
      border: false,
      path: StaticRoutes.Contact,
    },
    // {
    //   label: "LOG IN",
    //   options: [],
    //   border: false,
    //   path: StaticRoutes.Login,
    // },
    {
      label: "SIGN UP",
      options: [
        { label: "UPS", path: StaticRoutes.UPSPricing },
        { label: "AMERICAN", path: StaticRoutes.Bidding },
        { label: "ALASKA", path: StaticRoutes.TripBoard },
        { label: "JETSUITE", path: StaticRoutes.Bidding },
      ],
      border: true,
    },
  ],
  footerLists = [
    {
      header: "MENU",
      links: [
        { name: "Home", src: StaticRoutes.Home },
        { name: "Contact Us", src: StaticRoutes.Contact },
        { name: "Sign Up", src: StaticRoutes.Home },
      ],
    },
    {
      header: "PRODUCTS",
      links: [
        { name: "Bidding", src: StaticRoutes.Bidding },
        { name: "Trip Board", src: StaticRoutes.TripBoard },
        { name: "Seniority", src: StaticRoutes.Seniority },
        { name: "Pricing", src: StaticRoutes.UPSPricing },
      ],
    },
    {
      header: "TECH SUPPORT",
      links: [
        { name: "tech@bidpro.com", src: "mailto:tech@bidpro.com" },
        { name: "1-800-918-4980", src: "tel:18009184980" },
      ],
    },
  ],
}) => {
  //test shit
  const navigate = useNavigate();
  const navListWithNavigate = navList.map((item) => ({
    ...item,
    onClick: () => navigate(item.path),
    options: item.options?.map((option) => ({
      ...option,
      onClick: () => navigate(option.path),
    })),
  }));

  return (
    <>
      <Nav isStatic={true} navItems={navListWithNavigate} />
      <div className={styles.pageContainer}>
        <div className={styles.passwordResetContainer}>
          <h2>Your temporary password has been sent!</h2>
          <p className={styles.body}>
            Please check your email inbox for an email from us. This temporary
            password can be used to login to your account.
            <br />
            If you do not see the email in your inbox, please check your "Junk"
            or "Spam" mail folder. Once logged in you will be prompted to reset
            your password.
            <br />
            If you run into any issues or do not recieve an email from us,
            please contact support!
          </p>

          <div className={styles.centerButton}>
            <button
              // className={styles.buttonV3}
              className={classNames(styles.buttonV3, styles.buttonV3Width)}
              onClick={() => navigate("/login")}
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
      <Footer lists={footerLists} inverse={true} className={styles.footer} />
    </>
  );
};

PasswordResetSent.propTypes = {
  navList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
        })
      ),
      border: PropTypes.bool,
      path: PropTypes.string.isRequired,
    })
  ),
};

export default PasswordResetSent;
